module.exports = __webpack_public_path__ + "static/img/IMG_20160327_090546.0181f6db.jpg";